import React from "react";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faEye, faPen, faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import AdminHaut from "../../components/AdminHaut";
import { listActu } from "../../actions/actus";
import { connect } from "react-redux";
import Alert from "../../components/Alert";
import { tempAlWait } from "../../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";
import AdminItemActu from "../../components/AdminItemActu";

class AdminActus extends React.Component {
    state = {
        menuActive: false,
        opts: [
            {
                type: 'link',
                ttl: "Ajouter une actualité",
                ico: faPlus,
                link: "/admin/actus/ajout",
                action: null,
                col: null
            }
        ],
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        datas: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.listActu({nb: null});
            this.setState({
                alert: tempAlWait()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listActu({nb: null});
                this.setState({
                    alert: tempAlWait()
                })
            }
        }

        if (prevProps.redListActu != this.props.redListActu) {
            this.setState({
                alert: this.props.redListActu.alert,
                datas: this.props.redListActu.datas
            })
        }
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Les actualités"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.length == 0 ?
                        <h2 className="admin__empty">Aucune actualité n'a été créée pour le moment.</h2> :
                        <ul className="admin__list">
                            {
                                this.state.datas.map((data, key) => {
                                    return <AdminItemActu
                                        data={data}
                                        key={`actu-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.listActu({nb: null});
                                            }
                                        }}
                                    />
                                })
                            }
                        </ul>
                }
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redListActu: state.redListActu,
    }
}

const mapDispatchToProps = {
    listActu
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminActus);
